import { render, staticRenderFns } from "./sortPersonTeam.vue?vue&type=template&id=375b0c8c&scoped=true"
import script from "./sortPersonTeam.vue?vue&type=script&lang=js"
export * from "./sortPersonTeam.vue?vue&type=script&lang=js"
import style0 from "./sortPersonTeam.vue?vue&type=style&index=0&id=375b0c8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375b0c8c",
  null
  
)

export default component.exports